import React from 'react';
import PropTypes from 'prop-types';
import toLower from 'ramda/src/toLower';
import replace from 'ramda/src/replace';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import { inPage } from '~/services/util';
import { LibraryTypes } from '~/services/config';

class DocumentsDetail extends React.PureComponent {
    state = { current: 1, per: 5 };

    render() {
        const { current, per } = this.state;
        const { data } = this.props;

        return (
            <div className="career-required-instances">
                <div className="documents">
                    {data.map((item, index) => {
                        const type = toLower(replace(/\s/g, '', item.data.type));
                        const thumbnail = LibraryTypes[type].icon;
                        if (inPage(index, current, per)) {
                            return (
                                <div className="d-flex jc-between py-2" key={`doc${index}`}>
                                    <div className="d-flex ai-center">
                                        <Icon name="far fa-circle me-3" size={25} color="#969faa" />
                                        <Thumbnail source={thumbnail} label={item.data.type} size="tiny" />
                                        <div className="ml-3">
                                            <p className="dsl-b14 text-400 mb-1">{item.title}</p>
                                            <p className="dsl-m12 mb-0">Completed: none</p>
                                        </div>
                                    </div>
                                    <div className="edit" />
                                </div>
                            );
                        }
                    })}
                </div>
                <Pagination
                    current={current}
                    per={per}
                    pers={[5, 10, 'all']}
                    total={Math.ceil(data.length / per)}
                    onPer={(e) => this.setState({ per: e })}
                    onChange={(e) => this.setState({ current: e })}
                />
            </div>
        );
    }
}

DocumentsDetail.propTypes = {
    data: PropTypes.array,
};

DocumentsDetail.defaultProps = {
    data: [],
};

export default DocumentsDetail;
